import React from 'react';
import PropTypes from 'prop-types';
import { contentfulViews } from '@glowforge/ui-common';
import { pagePropType } from 'app/common/selectors/page';
import JobsList from './jobs-list';

import './jobs-home.less';

const { Page } = contentfulViews;

const JobsHomePage = (props) => {
  const customSections = {
    'jobs-page-postings': {
      component: JobsList,
      props: {
        jobs: props.jobs,
      },
    },
  };

  return (
    <Page className='JobsHomePage' {...props.page} customSections={customSections} />
  );
};

JobsHomePage.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
  page: PropTypes.shape(pagePropType),
};

JobsHomePage.defaultProps = {
  jobs: null,
  page: {
    sections: [],
  },
};

export default JobsHomePage;



// WEBPACK FOOTER //
// ./app/components/company/jobs-home.jsx